<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white">please wait!.. </p>
</ngx-spinner>
        <div class="security_tabs">
            <div class="srch_tabs">
              <div class="srch_here">
                <h5>Year</h5>
                <select class="form-control rr_year_sel" (change)="onChangeYear($event)" [ngModel]="currentYear">
                  <option disabled></option>
                  <option *ngFor="let yrs of years" [value]="yrs.name">{{yrs.name}}</option>
                </select>
                <h5> Search </h5>
                <input type="text" class="form-control" [(ngModel)]="search">
                
              </div>
              
            </div>
            
             <nz-tabset nzType="card" class="completed_repairs">
                  <nz-tab *ngFor="let mont of completedArr; let i = index;" [nzTitle]="mont.month" (nzClick)="getCompletedListDataFront(selectedOutlet, mont.monthNumber, selectedYear, i)">
                  <div class="table-responsive contact_new_table table_contact">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Date</th>
                          <th scope="col" style="width:200px">Name & <br>Contact</th>
                          <th scope="col"style="width:200px" >Phone<br>Problem</th>
                          <th scope="col">Model</th>
                          <th scope="col">Outlet</th>
                          <th scope="col">Collect</th>
                          <th scope="col">Estimated<br>Profit</th>
                          <th scope="col">Repair</th>
                          <th scope="col">Finish</th>
                          <th scope="col">Cost of<br>Warranty</th>
                          <!-- <th scope="col">Sent<br>SMS</th> -->
                          <th scope="col">Complete</th>
                          <th scope="col">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- <tr *ngFor="let list of mont.data | pipetype:search ">
                          <td>{{list.created * 1000 | date : 'longDate'}}</td>
                          <td>{{list.repairProcesses[0].customerId}} - {{list.repairProcesses[0].name}}</td>
                          <td>{{list.repairProcesses[0].phoneProblem}}</td>
                          <td>{{list.repairProcesses[0].phoneModel}}</td>
                          <td>{{list.outletName }}</td>
                          <td>{{list.repairProcesses[0].adminName}}</td>
                          <td>{{list.repairProcesses[2].estimatedPrice}}</td>
                          <td>{{list.repairProcesses[1].adminName}}</td>
                          <td>${{list.repairProcesses[2].price}}</td>
                          <td>${{list.costOfWarranty}}</td>
                          <td>{{list.yesNo==1 ? "Yes" : "No"}}</td>
                          <td>
                            <div class="action_td">
                              <a class="arrw" (click)="showPassModal(repairPro,list)"> <i class="fas fa-star"></i></a>
                              <a (click)="cancelled(list.id)" class="cross"> X </a>
                            </div>
                          </td>
                        </tr> -->
                        <tr *ngFor="let i of completedTabArr | pipetype:search">
                          <td>{{i.created * 1000 | date : 'longDate'}}</td>
                          <td>{{i.repairProcesses[0].customerId}} - {{i.repairProcesses[0].name}}</td>
                          <td>{{i.repairProcesses[0].phoneProblem}}</td>
                          <td>{{i.repairProcesses[0].phoneModel}}</td>
                          <td>{{i.outletName }}</td>
                          <td>{{i.repairProcesses[0].adminName}}</td>
                          <td>{{i.repairProcesses[2].estimatedPrice}}</td>
                          <td>{{i.repairProcesses[1].adminName}}</td>
                          <td>${{i.repairProcesses[2].price}}</td>
                          <td>${{i.costOfWarranty}}</td>
                          <!-- <td>{{i.yesNo==1 ? "Yes" : "No"}}</td> -->
                          <td>{{i.repairProcesses[2].adminName}}</td>
                          <td>
                            <div class="action_td">
                              <a class="arrw" (click)="showPassModal(repairPro,i)"> <i class="fas fa-star"></i></a>
                              <a (click)="cancelled(i.id)" class="cross"> X </a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  </nz-tab>
                </nz-tabset>
        </div>


          <ng-template #repairPro let-modal>
    <div id="Receipt_modal" class="login_me" role="dialog">
          <div class="modal-content">
            <button type="button" style="outline: none;" (click)="modal.dismiss('Cross click')" class="close close_modal" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span> </button>
            <button type="button" class="close close_modal" style="left: 40px;"><span aria-hidden="true" style="color: #354559;background: transparent;"><i class="fa-solid fa-circle-question fa-2x" (click)="showCommonFeedbackModal('2')"></i></span> </button>

            <div class="modal-header">
              <h4 class="modal-title"> Enter Details</h4>
            </div>
            <div class="modal-body">
               <div class="col-md-12">
                  <form class=" phone_detail_form" [formGroup]="edpform">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Admin</label>

                            <select formControlName="adminId">
                            <option *ngFor="let admn of repairAdmins" [value]="admn.id">{{admn.userName}}</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Repairman</label>
                            <input type="text" formControlName="repairBy" class="form-control" placeholder="New" readonly>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Cost of Warranty</label>
                            <input type="text" formControlName="costByWarranty" class="form-control" placeholder="Cost of Warranty">
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group" style="padding-top: 32px;">
                             <a class="save_bttn" (click)="onWarranty('1')" [ngClass]="{'active':isWarranty == '1'}"> Warranty </a>
                          </div>
                        </div>
                   </div>

                   <div class="row">
                         <div class="col-md-12">
                          <div class="form-group remarkk text-left">
                            <label>Notes</label>
                            <input type="text" formControlName="note3" class="form-control" placeholder="Notes">
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group remarkk text-left">
                            <label>Notes</label>
                            <input type="text" formControlName="note4" class="form-control" placeholder="Notes">
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group remarkk text-left">
                            <label>Notes</label>
                            <input type="text" formControlName="note" class="form-control" placeholder="Notes">
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group remarkk text-left">
                            <label>Notes</label>
                            <input type="text" formControlName="note1" class="form-control" placeholder="Notes">
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group remarkk text-left">
                            <label>Notes</label>
                            <input type="text" formControlName="note2" class="form-control" placeholder="Notes">
                          </div>
                        </div>

                    <div class="col-md-12 text-center">
                        <a class="save_btn" (click)="onWarranty('2')"> Save </a>
                         <a class="save_btn" (click)="modal.dismiss('Cross click')"> Cancel </a>
                   </div>
                   </div>
                  </form>
               </div>

            </div>
          </div>
      </div>
  </ng-template>
